import { render, staticRenderFns } from "./AlertActions.vue?vue&type=template&id=446d2fa5&"
import script from "./AlertActions.vue?vue&type=script&lang=js&"
export * from "./AlertActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports